<div class="export-format-wrapper">
  <h1 class="title"> {{ 'ExportFormat.Title' | translate }} </h1>

  <mat-form-field>
    <mat-label> {{ 'ExportFormat.ExportLabel' | translate }} </mat-label>
    <mat-select [formControl]="exportFormatControl" (selectionChange)="onFormatChange($event)">
      <mat-option *ngFor="let format of formats" [value]="format.value">
        {{ format.title | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
